import { errorMessage } from "../../lib/errors";
import { Banner } from "./Banner";
import { Button } from "./Button";

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <Banner tone="bad" action={onRetry && <Button size="sm" onClick={onRetry}>try again</Button>}>
      {errorMessage(error)}
    </Banner>
  );
}
